import Breadcrumb from "app/containers/Features/components/Breadcrumb";
import {
  selectSelectedTeam,
  selectTeamSetting,
  selectTicketList,
  selectUserDetailsData,
} from "app/redux/selector";
import { actions as appAction } from "app/redux/slice";
import { actions as boardSettingActions } from "./Settings/redux/slice";
import { IBoard, IUserTeams } from "app/types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { selectSelectedBoard } from "../redux/selector";
import { actions } from "../redux/slice";
import AddBoard from "./AddBoard";
import BoardMenu from "./BoardMenu";
import CreateTaskButton from "./CreateTaskButton";
import FilterBar from "./FilterBar";
import FilterButton from "./FilterButton";
import SettingsButton from "./Settings/SettingsButton";
import StartButton from "./StarButton";
import { selectDraftBoardForm } from "./Settings/redux/selector";

export default function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const pathname = location.pathname;
  const dispatch = useDispatch();
  const params = useParams();
  const teamSetting = useSelector(selectTeamSetting);
  const selectedTeam = useSelector(selectSelectedTeam);
  const userDetails = useSelector(selectUserDetailsData);
  const selectedBoard = useSelector(selectSelectedBoard);
  const ticketList = useSelector(selectTicketList);
  const boardFormData = useSelector(selectDraftBoardForm);
  const [filter, setFilter] = useState(false);
  useEffect(() => {
    if (params?.team && params.id) {
      dispatch(appAction.setSelectedProject(params.team));
      // call get board data API
      dispatch(boardSettingActions.getBoard({ id: params.id }));
    }
    return () => {};
  }, [params?.team]);

  // remove for now due to occur many times
  // useEffect(() => { 
  //   if (userDetails?.teamIds) {
  //     dispatch(appAction.doGetTeamsSetting({ data: userDetails?.teamIds }));
  //   }
  //   return () => {};
  // }, [userDetails?.teamIds]);

  useEffect(() => {
    if (teamSetting?.projects && params?.project) {
      dispatch(appAction.doGetSelectProjectSetting(params?.project as string));
    }
    return () => {};
  }, [teamSetting?.projects]);

  const hadleFavoriteBoard = () => {
    const boardId = selectedBoard.length > 0 ? selectedBoard[0]._id : null;
    if (boardId) {
      dispatch(actions.addFavoriteBoard({ id: boardId }));
    }
  };


useEffect(() => {

  if (
    params.id &&
    teamSetting?.projects[0]?.boards &&
    ticketList &&
    boardFormData 
  ) {
    dispatch(
      actions.doGetSelectedBoardData({
        id: params.id as string,
        callback() {},
      })
    );
  }
}, [params.id, teamSetting?.projects[0]?.boards, ticketList, boardFormData]);


  return (
    <div className="flex flex-col gap-3 relative ">
      <Breadcrumb teams={selectedTeam as IUserTeams} />
      <div className="flex flex-row justify-between items-center min-w-max flex-grow px-[24px]">
        <div className="flex flex-row gap-[6px] items-center">
          <BoardMenu
            boardData={teamSetting?.projects[0]?.boards as IBoard[]}
          />  
          <AddBoard />
        </div>
        {!pathname.endsWith("/boards") && (
          <div className="flex flex-row gap-[16px] items-center">
            <StartButton
              onClick={hadleFavoriteBoard}
              isFavorite={
                selectedBoard[0]?.settings?.favorite == 0 ? false : true
              }
            />
            <SettingsButton />
            <FilterButton filter={filter} setFilter={setFilter} />
            <CreateTaskButton />
          </div>
        )}
      </div>
      {filter && <FilterBar />}
      <div className="overflow-visible">{children}</div>
    </div>
  );
}
